import React from 'react';

import { useTitle } from '@admin/hooks/use_title';
import { RateAdjustment__Upload__Product } from '@admin/schema';

import { RateAdjustmentUploaderForm } from './form';

export const DoorToDoorRateAdjustmentUploaderForm: React.FC = () => {
  useTitle('Rate Adjustments');
  return <RateAdjustmentUploaderForm product={RateAdjustment__Upload__Product.DoorToDoor} />;
};
